"use client";

import React from "react";

import ContactDetails from "@/app/components/contact-details";
import ContactDetailsProvider from "@/app/components/contact-details/provider/contact-details.provider";
import { ContactDetailsPageType } from "@/app/components/contact-details/types/contact-details.type";

function ContactDetailsPage({ cmsData }: ContactDetailsPageType) {
  return (
    <ContactDetailsProvider initialValue={cmsData}>
      <ContactDetails />
    </ContactDetailsProvider>
  );
}

export default ContactDetailsPage;
